export class PurchaseHistoryItemDto {
  public seq: number;
  public id: number;
  public timestamp: Date;
  public value: number;
  public location: string;
  public hasReceipt: boolean;
}
